export default __webpack_public_path__ + "static/media/AvatarKids-01.91ad5190.png";